import { map, toSafeInteger } from 'lodash'

import { gql, useMutation } from '@apollo/client'
import { msg } from '@lingui/macro'
import { useLingui } from '@lingui/react'

const SET_AUTHORIZATION_GROUP = gql`
  mutation SetAuthorizationGroup($groupId: ID!, $value: Int!, $objectId: ID!) {
    setAuthorizationGroup(
      groupId: $groupId
      value: $value
      objectId: $objectId
    ) {
      id
    }
  }
`

const authOptions = {
  1: msg`Con permessi di lettura`,
  3: msg`Con permessi di gestione`,
}

const GroupAuthSelect = ({ elementId, authValue, groupId }) => {
  const { _ } = useLingui()
  const [mutate, { loading }] = useMutation(SET_AUTHORIZATION_GROUP, {
    refetchQueries: ['GetElementAuthorizationForGroups'],
  })

  const onChange = ({ target }) => {
    return mutate({
      variables: {
        groupId: groupId,
        value: toSafeInteger(target.value),
        objectId: elementId,
      },
    })
  }

  return (
    <select
      className="block border-gray-300 focus:border-indigo-300 rounded-md shadow-sm disabled:opacity-50 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 form-select sm:w-auto w-full"
      defaultValue={authValue}
      onChange={onChange}
      disabled={loading}
    >
      {map(authOptions, (name, value: number) => (
        <option key={value} value={value}>
          {_(name)}
        </option>
      ))}
    </select>
  )
}

export default GroupAuthSelect
